import { render, staticRenderFns } from "./ContractDetails.view.vue?vue&type=template&id=70dcaee5&"
import script from "./ContractDetails.view.vue?vue&type=script&lang=js&"
export * from "./ContractDetails.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70dcaee5')) {
      api.createRecord('70dcaee5', component.options)
    } else {
      api.reload('70dcaee5', component.options)
    }
    module.hot.accept("./ContractDetails.view.vue?vue&type=template&id=70dcaee5&", function () {
      api.rerender('70dcaee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/sign/partials/ContractDetails.view.vue"
export default component.exports